import type { ReactNode } from 'react';

export type EmptyDataMessageProps = {
  text?: string;
  children?: ReactNode;
  fullHeight?: boolean;
};

export function EmptyDataMessage({ text, children, fullHeight }: EmptyDataMessageProps) {
  const effectiveFullHeightCssClass = fullHeight ? 'h-100' : '';

  return (
    <div
      className={`d-flex flex-column p-3 gap-2 align-items-center justify-content-center ${effectiveFullHeightCssClass}`}
    >
      {text != null && <div className="small">{text}</div>}
      {children}
    </div>
  );
}
